export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/patient')) return
  if (to.path === '/patient/login') return

  try {
    await useRequestFetch()('/api/patient/me')
  }
  catch {
    return navigateTo({
      path: '/patient/login',
      query: { redirect: to.fullPath },
    })
  }
})
